import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * ScrollToTop — resets the window scroll position to 0 on every pathname change.
 *
 * React Router does NOT restore scroll between routes by default. Without this
 * component, navigating from the bottom of `/features` to `/pricing` would land
 * the user at the bottom of the new page. This mounts once inside `<BrowserRouter>`
 * and re-runs its effect whenever the pathname changes.
 *
 * Hash-only changes (e.g. `/pricing` → `/pricing#faq`) are NOT forced to top —
 * they're left alone so native anchor jumps still work.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    // Instant jump. Smooth scroll feels laggy on page transitions and fights with
    // scroll-triggered reveal animations that run on mount.
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  }, [pathname])

  return null
}
